import { render, staticRenderFns } from "./StartVoyageForm.vue?vue&type=template&id=04dfe7f4&"
import script from "./StartVoyageForm.vue?vue&type=script&lang=js&"
export * from "./StartVoyageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports